export default __webpack_public_path__ + "static/media/213.bd50c9f2.gif";